import { useEffect, useState } from "react";

const useSortedSignals = ({
  data,
  allTradeSuggestionData,
  analyze,
  suggestions,
  aiMarketType,
}) => {
  const [sortedData, setSortedData] = useState([]);

  // console.log(suggestions, [...allTradeSuggestionData, ...data]);

  useEffect(() => {
    if (!data?.length) return;

    const nonHoldLiveSignal = suggestions
      ?.filter((s) => s.prediction && s.prediction !== "Hold")
      ?.map((s) => s.symbol);

    let allSignals = [...data, ...allTradeSuggestionData]?.filter(
      (signal) => signal?.MARKET_TYPE === aiMarketType,
    );

    if (aiMarketType === "crypto") {
      const defaultSignals = allSignals?.filter(
        (signal) =>
          !analyze.find(
            (item) =>
              item?.SYMBOL_NAME?.split("/")?.[0] ===
              signal?.SYMBOL_NAME?.split("/")?.[0],
          ),
      );
      allSignals = [...defaultSignals, ...analyze];
      // allSignals
      //   ?.filter(
      //     (signal) =>
      //       !analyze.find(
      //         (item) =>
      //           item?.SYMBOL_NAME?.split("/")?.[0] ===
      //           signal?.SYMBOL_NAME?.split("/")?.[0],
      //       ),
      //   )
      //   .push(...analyze);
    }

    const nonHoldSignals = [...allSignals]
      ?.filter(
        (s) =>
          nonHoldLiveSignal?.includes(s.SYMBOL_NAME) ||
          !s?.TRADE_TYPE?.includes("Hold"),
      )
      ?.sort((a, b) => (nonHoldLiveSignal?.includes(b.SYMBOL_NAME) ? 1 : -1));

    const otherSignals = [...allSignals]
      ?.filter(
        (s) =>
          !nonHoldLiveSignal?.includes(s?.SYMBOL_NAME) &&
          s?.TRADE_TYPE?.includes("Hold"),
      )
      ?.sort((a, b) => b.SIGNAL_STRENGTH - a.SIGNAL_STRENGTH);

    // let sortedOtherSignals = [...analyze];
    //
    // if (aiMarketType === "crypto") {
    //   const nonHolds = sortedOtherSignals
    //     ?.filter(
    //       (s) =>
    //         nonHoldLiveSignal?.includes(s.SYMBOL_NAME) ||
    //         !s?.TRADE_TYPE?.includes("Hold"),
    //     )
    //     ?.sort((a, b) => (nonHoldLiveSignal?.includes(b.SYMBOL_NAME) ? 1 : -1));
    //
    //   const moreSignals = sortedOtherSignals
    //     ?.filter(
    //       (s) =>
    //         !nonHoldLiveSignal?.includes(s?.SYMBOL_NAME) &&
    //         s?.TRADE_TYPE?.includes("Hold"),
    //     )
    //     ?.sort((a, b) => b.SIGNAL_STRENGTH - a.SIGNAL_STRENGTH);
    //
    //   sortedOtherSignals = [...nonHolds, ...moreSignals];
    // }

    const finalSortedData = [...nonHoldSignals, ...otherSignals];

    // const signalSymbols = suggestions
    //   ?.filter((item) => item?.prediction)
    //   ?.map((item) => item?.symbol);
    //
    // const matchedSymbols = allSignals
    //   ?.filter((item) => signalSymbols?.includes(item?.SYMBOL_NAME))
    //   ?.sort((a, b) => (b?.TRADE_TYPE.includes("Hold") ? 1 : -1))
    //   ?.sort((a, b) => {
    //     const bPrediction = suggestions?.find(
    //       (s) => s?.symbol === `${b?.SYMBOL_NAME}`,
    //     )?.prediction;
    //     return bPrediction === "Hold" ? -1 : 1;
    //   });
    //
    // const nonMatchedNonHolds = allSignals?.filter(
    //   (item) =>
    //     !signalSymbols?.includes(item?.SYMBOL_NAME) &&
    //     !item?.TRADE_TYPE?.includes("Hold"),
    // );
    //
    // const highestHoldSignals = allSignals
    //   .filter(
    //     (item) =>
    //       !signalSymbols?.includes(item?.SYMBOL_NAME) &&
    //       item.TRADE_TYPE?.includes("Hold"),
    //   )
    //   ?.sort((a, b) => b?.SIGNAL_STRENGTH - a?.SIGNAL_STRENGTH);
    //
    // const finalSortedData =
    //   aiMarketType !== "crypto"
    //     ? allSignals?.sort((a, b) => (b?.TRADE_TYPE.includes("Hold") ? -1 : 1))
    //     : [
    //         ...analyze,
    //         ...matchedSymbols,
    //         ...nonMatchedNonHolds,
    //         ...highestHoldSignals,
    //       ];

    setSortedData(finalSortedData);
  }, [data, allTradeSuggestionData, analyze, suggestions, aiMarketType]);

  return sortedData;
};

export default useSortedSignals;
